export default __webpack_public_path__ + "static/media/外观设计专利证书.ce26f7c2.png";